import { render, staticRenderFns } from "./form_table_column.vue?vue&type=template&id=10893414"
import script from "./form_table_column.vue?vue&type=script&lang=js"
export * from "./form_table_column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10893414')) {
      api.createRecord('10893414', component.options)
    } else {
      api.reload('10893414', component.options)
    }
    module.hot.accept("./form_table_column.vue?vue&type=template&id=10893414", function () {
      api.rerender('10893414', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/components/form/components/form_table_column.vue"
export default component.exports